const Page = {
  MIN_HEIGHT: {
    full_screen: 'calc(100svh - 125px)',
    small_screen: 'calc(100svh - 80px)',
  },
};

export default Page;
